/* global BackboneEx */
import React from 'react';
import ReactDOM from 'react-dom';
import { Reconnect } from 'federation/Reconnect';
import { openChat } from 'utilities/support-chat';

App.Views.TreatwellPay = BackboneEx.View.Main.extend({
  initialize() {
    // Order status's Contact support can't call openChat() directly (Reconnect
    // can't import Connect code), so it dispatches this event instead — see
    // reconnect's useOpenSupportChat.ts. Registered here, not in render(),
    // which runs again on every venue switch.
    window.addEventListener('reconnect:open-support-chat', (event) =>
      openChat(event.detail?.source ?? 'treatwell pay order status'),
    );
  },

  render() {
    // Gate direct URL access to match the nav gating (TEF-4242).
    if (!App.isTreatwellPayEligible()) {
      window.location.href = '/';
      return;
    }
    App.headerView.setModule('treatwell-pay');
    const node = this.$('#treatwell-pay-section').get(0);
    if (node) {
      // showTapToPay is omitted on web: the Tap to Pay section is app-only (TEF-4242, AC #4).
      // Keyed by venue so an in-place venue switch remounts the island with
      // the new venue's config instead of keeping the old one (TEF-4709).
      ReactDOM.render(<Reconnect key={App.getVenueId()} name="TreatwellPay" />, node);
    }
  },
});
